<template>
  <v-row no-gutters>
    <v-speed-dial direction="right" :open-on-hover="true">
      <template v-slot:activator>
        <v-btn slot="activator" color="orange" fab text small>
          <v-icon color="orange">touch_app</v-icon>
        </v-btn>
      </template>

      <v-tooltip bottom v-if="!ocultarVerLegajoVirtual">
        <template v-slot:activator="{ on }">
          <v-btn
            fab
            dark
            small
            color="blue"
            v-on="on"
            @click.stop="verLegajoVirtual()"
          >
            <v-icon>file_copy</v-icon>
          </v-btn>
        </template>
        <span>Legajo Virtual</span>
      </v-tooltip>

      <v-tooltip bottom v-if="!ocultarVerLegajo && !personaVacia">
        <template v-slot:activator="{ on }">
          <v-btn
            fab
            dark
            small
            color="purple"
            v-on="on"
            @click.stop="verLegajo()"
          >
            <v-icon>person</v-icon>
          </v-btn>
        </template>
        <span>Legajo</span>
      </v-tooltip>

      <v-tooltip bottom v-if="!ocultarVerLegajo && personaVacia">
        <template v-slot:activator="{ on }">
          <v-btn fab dark small color="purple" v-on="on">
            <v-icon>person_add_disabled</v-icon>
          </v-btn>
        </template>
        <span>No se puede visualizar, Legajo aún no creado</span>
      </v-tooltip>

      <v-tooltip
        bottom
        v-if="!ocultarVerCreditos && !user.esComer && !personaVacia"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            fab
            dark
            small
            color="green"
            v-on="on"
            @click.stop="verCreditos()"
          >
            <v-icon>playlist_add_check</v-icon>
          </v-btn>
        </template>
        <span>Créditos</span>
      </v-tooltip>

      <v-tooltip bottom v-if="!user.esComer && !personaVacia">
        <template v-slot:activator="{ on }">
          <v-btn
            fab
            dark
            small
            color="indigo"
            v-on="on"
            @click.stop="verContactos()"
          >
            <v-icon>history</v-icon>
          </v-btn>
        </template>
        <span>Contactos</span>
      </v-tooltip>

      <v-tooltip bottom v-if="!ocultarAnalisisCredito && solicitudId != null">
        <template v-slot:activator="{ on }">
          <v-btn fab dark small color="red" v-on="on" @click.stop="analizar()">
            <v-icon>thumbs_up_down</v-icon>
          </v-btn>
        </template>
        <span>Analizar</span>
      </v-tooltip>

      <v-tooltip bottom v-if="!ocultarAnalisisConsulta && solicitudId != null">
        <template v-slot:activator="{ on }">
          <v-btn
            fab
            dark
            small
            color="red"
            v-on="on"
            @click.stop="analizarConsulta()"
          >
            <v-icon color="white" v-if="!user.esComer">thumbs_up_down</v-icon>
            <v-icon v-else>info</v-icon>
          </v-btn>
        </template>
        <span v-if="!user.esComer">Analizar Consulta</span>
        <span v-else>Ver Detalle</span>
      </v-tooltip>

      <v-tooltip v-if="showCancelarAnalisis" bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            fab
            dark
            small
            color="red"
            v-on="on"
            @click.stop="cancelarAnalisisLocal()"
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </template>
        <span>Cancelar Analiis</span>
      </v-tooltip>
    </v-speed-dial>

    <!-- Ver Legajo Cliente  -->
    <v-dialog v-model="showLegajoPersona" width="1000">
      <legajo-persona :personaId="personaId"> </legajo-persona>
    </v-dialog>

    <!-- Ver Legajo Virtual  -->
    <v-dialog v-model="showLegajoVirtual" persistent width="850">
      <legajo-virtual
        :documento="documento"
        :solicitudId="solicitudId"
        :showCompletarDocumentacion="showCompletarDocumentacion"
        @close-dialog="showLegajoVirtual = false"
      >
      </legajo-virtual>
    </v-dialog>

    <!-- Analizar Solicitud  -->
    <v-dialog v-model="showAnalisisSolicitud" width="1000" persistent>
      <!-- <analisis-solicitud :SolicitudId="solicitudId" :Visible.sync="showAnalisisSolicitud" :FinAnalisis ="finAnalisisLocal"> </analisis-solicitud> -->
      <analisis-consulta
        :SolicitudId="solicitudId"
        :Visible.sync="showAnalisisSolicitud"
        :FinAnalisis="finAnalisisLocal"
      >
      </analisis-consulta>
    </v-dialog>

    <!-- Analizar Consulta  -->
    <v-dialog v-model="showAnalisisConsulta" width="1000" persistent>
      <analisis-consulta
        :SolicitudId="solicitudId"
        :Visible.sync="showAnalisisConsulta"
        :FinAnalisis="finAnalisisConsultaLocal"
      >
      </analisis-consulta>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

import LegajoPersona from '@/components/legajo/layout.vue';
import LegajoVirtual from '@/components/legajo/legajoVirtual.vue';
//import AnalisisSolicitudCredito from '../creditos/AnalisisCredito';
import AnalisisConsultaCredito from '../creditos/AnalisisConsulta';

export default {
  components: {
    //'analisis-solicitud': AnalisisSolicitudCredito,
    'analisis-consulta': AnalisisConsultaCredito,
    'legajo-persona': LegajoPersona,
    'legajo-virtual': LegajoVirtual,
  },
  data() {
    return {
      showLegajoPersona: false,
      showLegajoVirtual: false,
      showAnalisisSolicitud: false,
      showAnalisisConsulta: false,
    };
  },
  props: {
    personaId: {
      type: String,
    },
    documento: {
      type: String,
    },
    solicitudId: {
      type: String,
      default: null,
    },
    finAnalisis: Function,
    ocultarVerLegajo: {
      type: Boolean,
      default: false,
    },
    ocultarVerLegajoVirtual: {
      type: Boolean,
      default: false,
    },
    ocultarVerCreditos: {
      type: Boolean,
      default: false,
    },
    ocultarAnalisisCredito: {
      type: Boolean,
      default: false,
    },
    ocultarAnalisisConsulta: {
      type: Boolean,
      default: false,
    },
    showCancelarAnalisis: {
      type: Boolean,
      default: false,
    },
    showCompletarDocumentacion: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['user']),
    personaVacia() {
      return this.personaId == '00000000-0000-0000-0000-000000000000';
    },
  },
  methods: {
    ...mapMutations(['setActiveTask', 'setActiveSubTask']),
    ...mapActions(['cancelarAnalisis']),
    async verLegajo() {
      this.showLegajoPersona = true;
    },
    async verLegajoVirtual() {
      this.showLegajoVirtual = true;
    },
    async verCreditos() {
      var params = {
        width: 900,
        visible: true,
        personaId: this.personaId,
      };

      this.setActiveTask({ task: 'app-lista-creditos', props: params });
    },
    async verContactos() {
      var params = {
        width: 700,
        visible: true,
        personaId: this.personaId,
      };

      this.setActiveTask({ task: 'app-log-contactos', props: params });
    },
    async analizar() {
      this.showAnalisisSolicitud = true;
    },
    async finAnalisisLocal() {
      this.showAnalisisSolicitud = false;

      if (this.finAnalisis) this.finAnalisis();
    },
    async analizarConsulta() {
      this.showAnalisisConsulta = true;
    },
    async finAnalisisConsultaLocal() {
      this.showAnalisisConsulta = false;

      if (this.finAnalisis) this.finAnalisis();
    },
    async cancelarAnalisisLocal() {
      //este es un metodo de actions
      await this.cancelarAnalisis(this.solicitudId);

      this.emitRefreshLista();
    },
    emitRefreshLista() {
      this.$emit('refrescar-lista');
    },
  },
};
</script>
